"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function RectangleMdMobileSvg(t0) {
  const $ = _c(189);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path opacity={0.7} d="M480.159 975H162.159L162.159 405.079C162.159 317.202 233.358 246 321.139 246C408.919 246 480.159 317.243 480.159 405.079L480.159 975Z" fill="#4668C2" style={style("bottom center")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path d="M2.15906 -28L320.159 -28L320.159 131.02C320.159 218.842 248.96 290 161.18 290C73.3989 290 2.15908 218.801 2.15907 131.02L2.15906 -28Z" fill="#4668C2" style={style("top center")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== t5 || $[12] !== t7 || $[13] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[11] = t5;
          $[12] = t7;
          $[13] = t8;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== t4 || $[16] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[15] = t4;
          $[16] = t9;
          $[17] = t10;
        } else {
          t10 = $[17];
        }
        return t10;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[19] = t2;
          $[20] = t4;
        } else {
          t4 = $[20];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#9BD7D2" />;
          $[21] = t6;
        } else {
          t6 = $[21];
        }
        let t7;
        if ($[22] !== style) {
          t7 = <motion.path opacity={0.4} d="M490 721H245V259.48C245 191.821 299.855 137 367.484 137C435.114 137 490 191.852 490 259.48V721Z" fill="#85CDC7" style={style("bottom right")} />;
          $[22] = style;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        let t8;
        if ($[24] !== style) {
          t8 = <motion.path opacity={0.7} d="M6.64011e-05 -178L245 -178L245 284.311C245 352.085 190.146 407 122.516 407C54.8861 407 3.53211e-05 352.054 4.12434e-05 284.311L6.64011e-05 -178Z" fill="#85CDC7" style={style("top left")} />;
          $[24] = style;
          $[25] = t8;
        } else {
          t8 = $[25];
        }
        let t9;
        if ($[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[26] = t5;
          $[27] = t7;
          $[28] = t8;
          $[29] = t9;
        } else {
          t9 = $[29];
        }
        let t10;
        if ($[30] !== t4 || $[31] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[30] = t4;
          $[31] = t9;
          $[32] = t10;
        } else {
          t10 = $[32];
        }
        return t10;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[33] = t3;
        } else {
          t3 = $[33];
        }
        let t4;
        if ($[34] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[34] = t2;
          $[35] = t4;
        } else {
          t4 = $[35];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#00968C" />;
          $[36] = t6;
        } else {
          t6 = $[36];
        }
        let t7;
        if ($[37] !== style) {
          t7 = <motion.rect opacity={0.65} y={370} width={247} height={247} rx={16.4482} fill="#00A399" style={style("bottom left")} />;
          $[37] = style;
          $[38] = t7;
        } else {
          t7 = $[38];
        }
        let t8;
        if ($[39] !== style) {
          t8 = <motion.circle cx={370.5} cy={493.5} r={123.5} fill="#00A399" style={style("bottom right")} />;
          $[39] = style;
          $[40] = t8;
        } else {
          t8 = $[40];
        }
        let t9;
        if ($[41] !== style) {
          t9 = <motion.rect opacity={0.65} x={247} y={123} width={247} height={247} rx={16.4482} fill="#00A399" style={style("top right")} />;
          $[41] = style;
          $[42] = t9;
        } else {
          t9 = $[42];
        }
        let t10;
        if ($[43] !== style) {
          t10 = <motion.circle cx={123.5} cy={246.5} r={123.5} fill="#00A399" style={style("top left")} />;
          $[43] = style;
          $[44] = t10;
        } else {
          t10 = $[44];
        }
        let t11;
        if ($[45] !== t10 || $[46] !== t5 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[45] = t10;
          $[46] = t5;
          $[47] = t7;
          $[48] = t8;
          $[49] = t9;
          $[50] = t11;
        } else {
          t11 = $[50];
        }
        let t12;
        if ($[51] !== t11 || $[52] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[51] = t11;
          $[52] = t4;
          $[53] = t12;
        } else {
          t12 = $[53];
        }
        return t12;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[54] = t3;
        } else {
          t3 = $[54];
        }
        let t4;
        if ($[55] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[55] = t2;
          $[56] = t4;
        } else {
          t4 = $[56];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#FFB497" />;
          $[57] = t6;
        } else {
          t6 = $[57];
        }
        let t7;
        if ($[58] !== style) {
          t7 = <motion.path opacity={0.7} d="M255.899 649H44V436.567C43.9515 345.121 117.885 271 209.101 271H421V483.433C421 574.88 347.066 649 255.85 649" fill="#F8A98A" style={style("bottom center")} />;
          $[58] = style;
          $[59] = t7;
        } else {
          t7 = $[59];
        }
        let t8;
        if ($[60] !== style) {
          t8 = <motion.path opacity={0.7} d="M255.899 271H44V59.1286C43.9515 -32.0756 117.885 -106 209.101 -106H421V105.871C421 197.076 347.066 271 255.85 271" fill="#FFAF8F" style={style("top center")} />;
          $[60] = style;
          $[61] = t8;
        } else {
          t8 = $[61];
        }
        let t9;
        if ($[62] !== t5 || $[63] !== t7 || $[64] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[62] = t5;
          $[63] = t7;
          $[64] = t8;
          $[65] = t9;
        } else {
          t9 = $[65];
        }
        let t10;
        if ($[66] !== t4 || $[67] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[66] = t4;
          $[67] = t9;
          $[68] = t10;
        } else {
          t10 = $[68];
        }
        return t10;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[69] = t3;
        } else {
          t3 = $[69];
        }
        let t4;
        if ($[70] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[70] = t2;
          $[71] = t4;
        } else {
          t4 = $[71];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#CCE88A" />;
          $[72] = t6;
        } else {
          t6 = $[72];
        }
        let t7;
        if ($[73] !== style) {
          t7 = <motion.path d="M107.333 34L-222.167 364L107.333 694L436.833 364L107.333 34Z" fill="#C6E57D" style={style("center center")} />;
          $[73] = style;
          $[74] = t7;
        } else {
          t7 = $[74];
        }
        let t8;
        if ($[75] !== t5 || $[76] !== t7) {
          t8 = <g clipPath={t5}>{t6}{t7}</g>;
          $[75] = t5;
          $[76] = t7;
          $[77] = t8;
        } else {
          t8 = $[77];
        }
        let t9;
        if ($[78] !== t4 || $[79] !== t8) {
          t9 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t8}</svg>;
          $[78] = t4;
          $[79] = t8;
          $[80] = t9;
        } else {
          t9 = $[80];
        }
        return t9;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[81] = t3;
        } else {
          t3 = $[81];
        }
        let t4;
        if ($[82] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[82] = t2;
          $[83] = t4;
        } else {
          t4 = $[83];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#A6B9F1" />;
          $[84] = t6;
        } else {
          t6 = $[84];
        }
        let t7;
        if ($[85] !== style) {
          t7 = <motion.path d="M235.416 789.157H2.65439e-05V553.772C-0.0539061 452.445 82.0856 370.316 183.425 370.316H418.841V605.702C418.841 707.029 336.702 789.157 235.362 789.157" fill="#90A7E7" style={style("bottom center")} />;
          $[85] = style;
          $[86] = t7;
        } else {
          t7 = $[86];
        }
        let t8;
        if ($[87] !== style) {
          t8 = <motion.path d="M235.416 369.841H2.65439e-05V134.455C-0.0539061 33.1289 82.0856 -49 183.425 -49H418.841V186.386C418.841 287.712 336.702 369.841 235.362 369.841" fill="#9BB1EF" style={style("top center")} />;
          $[87] = style;
          $[88] = t8;
        } else {
          t8 = $[88];
        }
        let t9;
        if ($[89] !== t5 || $[90] !== t7 || $[91] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[89] = t5;
          $[90] = t7;
          $[91] = t8;
          $[92] = t9;
        } else {
          t9 = $[92];
        }
        let t10;
        if ($[93] !== t4 || $[94] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[93] = t4;
          $[94] = t9;
          $[95] = t10;
        } else {
          t10 = $[95];
        }
        return t10;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[96] = t3;
        } else {
          t3 = $[96];
        }
        let t4;
        if ($[97] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[97] = t2;
          $[98] = t4;
        } else {
          t4 = $[98];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#F0B464" />;
          $[99] = t6;
        } else {
          t6 = $[99];
        }
        let t7;
        if ($[100] !== style) {
          t7 = <motion.path opacity={0.7} d="M525.71 1008.82H177.036L177.036 384.315C177.036 288.022 255.103 210 351.351 210C447.599 210 525.71 288.067 525.71 384.315L525.71 1008.82Z" fill="#EFAC53" style={style("bottom right")} />;
          $[100] = style;
          $[101] = t7;
        } else {
          t7 = $[101];
        }
        let t8;
        if ($[102] !== style) {
          t8 = <motion.path d="M2.15903 -90.0005L350.833 -90.0005L350.833 84.3591C350.833 180.652 272.767 258.674 176.519 258.674C80.2707 258.674 2.15905 180.607 2.15904 84.3591L2.15903 -90.0005Z" fill="#EFAC53" style={style("top left")} />;
          $[102] = style;
          $[103] = t8;
        } else {
          t8 = $[103];
        }
        let t9;
        if ($[104] !== t5 || $[105] !== t7 || $[106] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[104] = t5;
          $[105] = t7;
          $[106] = t8;
          $[107] = t9;
        } else {
          t9 = $[107];
        }
        let t10;
        if ($[108] !== t4 || $[109] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[108] = t4;
          $[109] = t9;
          $[110] = t10;
        } else {
          t10 = $[110];
        }
        return t10;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[111] = t3;
        } else {
          t3 = $[111];
        }
        let t4;
        if ($[112] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[112] = t2;
          $[113] = t4;
        } else {
          t4 = $[113];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#007190" />;
          $[114] = t6;
        } else {
          t6 = $[114];
        }
        let t7;
        if ($[115] !== style) {
          t7 = <motion.path opacity={0.4} d="M585.082 808.675H292.541V257.578C292.541 176.787 358.04 111.326 438.793 111.326C519.546 111.326 585.082 176.825 585.082 257.578V808.675Z" fill="#008AAA" style={style("bottom right")} />;
          $[115] = style;
          $[116] = t7;
        } else {
          t7 = $[116];
        }
        let t8;
        if ($[117] !== style) {
          t8 = <motion.path opacity={0.7} d="M9.14817e-05 -263.675L292.541 -263.675L292.541 287.422C292.541 368.213 227.042 433.674 146.289 433.674C65.5364 433.674 6.67612e-05 368.175 7.38209e-05 287.422L9.14817e-05 -263.675Z" fill="#008AAA" style={style("top left")} />;
          $[117] = style;
          $[118] = t8;
        } else {
          t8 = $[118];
        }
        let t9;
        if ($[119] !== t5 || $[120] !== t7 || $[121] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[119] = t5;
          $[120] = t7;
          $[121] = t8;
          $[122] = t9;
        } else {
          t9 = $[122];
        }
        let t10;
        if ($[123] !== t4 || $[124] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[123] = t4;
          $[124] = t9;
          $[125] = t10;
        } else {
          t10 = $[125];
        }
        return t10;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[126] = t3;
        } else {
          t3 = $[126];
        }
        let t4;
        if ($[127] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[127] = t2;
          $[128] = t4;
        } else {
          t4 = $[128];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[129] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#86CD9F" />;
          $[129] = t6;
        } else {
          t6 = $[129];
        }
        let t7;
        if ($[130] !== style) {
          t7 = <motion.path d="M236.63 789.236H2.66807e-05V552.637C-0.054184 450.789 82.5087 368.236 184.371 368.236H421V604.835C421 706.684 338.437 789.236 236.575 789.236" fill="#77C793" style={style("bottom center")} />;
          $[130] = style;
          $[131] = t7;
        } else {
          t7 = $[131];
        }
        let t8;
        if ($[132] !== style) {
          t8 = <motion.path d="M236.63 368H2.66807e-05V131.401C-0.054184 29.5522 82.5087 -53 184.371 -53H421V183.599C421 285.448 338.437 368 236.575 368" fill="#77C793" style={style("top center")} />;
          $[132] = style;
          $[133] = t8;
        } else {
          t8 = $[133];
        }
        let t9;
        if ($[134] !== t5 || $[135] !== t7 || $[136] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[134] = t5;
          $[135] = t7;
          $[136] = t8;
          $[137] = t9;
        } else {
          t9 = $[137];
        }
        let t10;
        if ($[138] !== t4 || $[139] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[138] = t4;
          $[139] = t9;
          $[140] = t10;
        } else {
          t10 = $[140];
        }
        return t10;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[141] = t3;
        } else {
          t3 = $[141];
        }
        let t4;
        if ($[142] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[142] = t2;
          $[143] = t4;
        } else {
          t4 = $[143];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#FFD152" />;
          $[144] = t6;
        } else {
          t6 = $[144];
        }
        let t7;
        if ($[145] !== style) {
          t7 = <motion.path d="M107.333 -116L-280.667 272L107.333 660L495.333 272L107.333 -116Z" fill="#FFCC3D" style={style("center center")} />;
          $[145] = style;
          $[146] = t7;
        } else {
          t7 = $[146];
        }
        let t8;
        if ($[147] !== t5 || $[148] !== t7) {
          t8 = <g clipPath={t5}>{t6}{t7}</g>;
          $[147] = t5;
          $[148] = t7;
          $[149] = t8;
        } else {
          t8 = $[149];
        }
        let t9;
        if ($[150] !== t4 || $[151] !== t8) {
          t9 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t8}</svg>;
          $[150] = t4;
          $[151] = t8;
          $[152] = t9;
        } else {
          t9 = $[152];
        }
        return t9;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[153] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[153] = t3;
        } else {
          t3 = $[153];
        }
        let t4;
        if ($[154] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[154] = t2;
          $[155] = t4;
        } else {
          t4 = $[155];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[156] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#2B52B8" />;
          $[156] = t6;
        } else {
          t6 = $[156];
        }
        let t7;
        if ($[157] !== style) {
          t7 = <motion.path opacity={0.7} d="M-5.52169e-06 -197L266 -197L266 304.824C266 378.392 206.444 438 133.017 438C59.5905 438 -2.53035e-05 378.357 -1.8875e-05 304.824L-5.52169e-06 -197Z" fill="#2F5FD6" style={style("top left")} />;
          $[157] = style;
          $[158] = t7;
        } else {
          t7 = $[158];
        }
        let t8;
        if ($[159] !== style) {
          t8 = <motion.path opacity={0.4} d="M533 780H266V278.176C266 204.608 325.78 145 399.483 145C473.185 145 533 204.643 533 278.176V780Z" fill="#2F5FD6" style={style("bottom right")} />;
          $[159] = style;
          $[160] = t8;
        } else {
          t8 = $[160];
        }
        let t9;
        if ($[161] !== t5 || $[162] !== t7 || $[163] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[161] = t5;
          $[162] = t7;
          $[163] = t8;
          $[164] = t9;
        } else {
          t9 = $[164];
        }
        let t10;
        if ($[165] !== t4 || $[166] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[165] = t4;
          $[166] = t9;
          $[167] = t10;
        } else {
          t10 = $[167];
        }
        return t10;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[168] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="421" height="544" fill="white" />;
          $[168] = t3;
        } else {
          t3 = $[168];
        }
        let t4;
        if ($[169] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[169] = t2;
          $[170] = t4;
        } else {
          t4 = $[170];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="421" height="544" fill="#1A3C82" />;
          $[171] = t6;
        } else {
          t6 = $[171];
        }
        let t7;
        if ($[172] !== style) {
          t7 = <motion.rect opacity={0.65} y={366} width={255} height={255} rx={16.4482} fill="#3254A2" style={style("bottom left")} />;
          $[172] = style;
          $[173] = t7;
        } else {
          t7 = $[173];
        }
        let t8;
        if ($[174] !== style) {
          t8 = <motion.circle cx={382.5} cy={493.5} r={127.5} fill="#3254A2" style={style("bottom right")} />;
          $[174] = style;
          $[175] = t8;
        } else {
          t8 = $[175];
        }
        let t9;
        if ($[176] !== style) {
          t9 = <motion.rect opacity={0.65} x={255} y={111} width={255} height={255} rx={16.4482} fill="#3254A2" style={style("top right")} />;
          $[176] = style;
          $[177] = t9;
        } else {
          t9 = $[177];
        }
        let t10;
        if ($[178] !== style) {
          t10 = <motion.circle cx={127.5} cy={238.5} r={127.5} fill="#3254A2" style={style("top left")} />;
          $[178] = style;
          $[179] = t10;
        } else {
          t10 = $[179];
        }
        let t11;
        if ($[180] !== t10 || $[181] !== t5 || $[182] !== t7 || $[183] !== t8 || $[184] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[180] = t10;
          $[181] = t5;
          $[182] = t7;
          $[183] = t8;
          $[184] = t9;
          $[185] = t11;
        } else {
          t11 = $[185];
        }
        let t12;
        if ($[186] !== t11 || $[187] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 421 544" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[186] = t11;
          $[187] = t4;
          $[188] = t12;
        } else {
          t12 = $[188];
        }
        return t12;
      }
    default:
      {
        return null;
      }
  }
}
const RectangleMdMobileColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-[421/544]";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <RectangleMdMobileSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
RectangleMdMobileColorBlock.displayName = "RectangleMdMobileColorBlock";
export { RectangleMdMobileColorBlock };